import React from 'react';
import { BrowserRouter, Navigate, Routes, Route, useLocation } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import SeoManager from './components/SeoManager';
import CookieConsentBanner from './components/CookieConsentBanner';
import GoogleTracking from './components/GoogleTracking';
import PageTransitionProvider from './components/PageTransitionProvider';

function HashScroller() {
  const { hash, pathname } = useLocation();
  React.useEffect(() => {
    if (!hash) return;
    const id = hash.replace('#', '');
    const target = document.getElementById(id);
    if (!target) return;
    requestAnimationFrame(() => {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }, [hash, pathname]);
  return null;
}

const ActionGame = React.lazy(() => import('./pages/ActionGame'));
const Karaoke = React.lazy(() => import('./pages/Karaoke'));
const Admin = React.lazy(() => import('./pages/Admin'));
const TeamBuilding = React.lazy(() => import('./pages/TeamBuilding'));
const Privatisation = React.lazy(() => import('./pages/Privatisation'));
const Seminaire = React.lazy(() => import('./pages/Seminaire'));
const InfosPratiques = React.lazy(() => import('./pages/InfosPratiques'));
const FormuleEvgEvjf = React.lazy(() => import('./pages/FormuleEvgEvjf'));
const FormuleAnniversaireEnfant = React.lazy(() => import('./pages/FormuleAnniversaireEnfant'));
const Contact = React.lazy(() => import('./pages/Contact'));
const Actualites = React.lazy(() => import('./pages/Actualites'));
const MentionsLegalesPage = React.lazy(() => import('./pages/LegalPages').then((module) => ({ default: module.MentionsLegalesPage })));
const PrivacyPolicyPage = React.lazy(() => import('./pages/LegalPages').then((module) => ({ default: module.PrivacyPolicyPage })));
const CookiePolicyPage = React.lazy(() => import('./pages/LegalPages').then((module) => ({ default: module.CookiePolicyPage })));

function PageFallback() {
  return <div className="min-h-screen bg-[#14151f]" aria-hidden="true" />;
}

export default function App() {
  return (
    <BrowserRouter>
      <SeoManager />
      <HashScroller />
      <CookieConsentBanner />
      <GoogleTracking />
      <PageTransitionProvider>
      <React.Suspense fallback={<PageFallback />}>
        <Routes>
          <Route
            path="/admin-gameside-caen"
            element={(
              <Admin />
            )}
          />
          <Route path="/admin" element={<Navigate to="/" replace />} />
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="nos-activites/action-game" element={<ActionGame />} />
            <Route path="nos-activites/karaoke" element={<Karaoke />} />
            <Route path="entreprises/team-building" element={<TeamBuilding />} />
            <Route path="entreprises/privatisation" element={<Privatisation />} />
            <Route path="entreprises/seminaire" element={<Seminaire />} />
            <Route path="infos-pratiques" element={<InfosPratiques />} />
            <Route path="actualites" element={<Actualites />} />
            <Route path="contact" element={<Contact />} />
            <Route path="formules/evg-evjf" element={<FormuleEvgEvjf />} />
            <Route path="formules/evjf" element={<Navigate to="/formules/evg-evjf" replace />} />
            <Route path="formules/evg" element={<Navigate to="/formules/evg-evjf" replace />} />
            <Route path="formules/anniversaire-enfant" element={<FormuleAnniversaireEnfant />} />
            <Route path="formules/anniversaire-adulte" element={<Navigate to="/contact" replace />} />
            <Route path="mentions-legales" element={<MentionsLegalesPage />} />
            <Route path="politique-de-confidentialite" element={<PrivacyPolicyPage />} />
            <Route path="politique-de-cookies-ue" element={<CookiePolicyPage />} />
            <Route path="politique-de-cookies" element={<Navigate to="/politique-de-cookies-ue" replace />} />
          </Route>
        </Routes>
      </React.Suspense>
      </PageTransitionProvider>
    </BrowserRouter>
  );
}
